import React, { useEffect, useState } from 'react';
import './styles.scss';

interface TargetHintDetail {
  key?: string | null;
  label?: string;
}

// The prompt under the crosshair while a player is looked at: the key that opens the ALT menu. Driven by
// skymp5-client's identityService.ts (updateHint), in the page instead of the game's own text so it reads
// in the interface's font and weight.
const TargetHint: React.FC = () => {
  const [hint, setHint] = useState<{ key: string; label: string } | null>(null);

  useEffect(() => {
    const onHint = (e: Event) => {
      const detail = (e as CustomEvent<TargetHintDetail>).detail || {};
      if (!detail.key) {
        setHint(null);
        return;
      }
      setHint({ key: String(detail.key), label: detail.label ? String(detail.label) : 'Menu' });
    };
    window.addEventListener('skymp5-client:targetHint', onHint);
    return () => window.removeEventListener('skymp5-client:targetHint', onHint);
  }, []);

  if (!hint) return null;
  return (
    <div className="target-hint" role="status">
      <kbd className="target-hint__key">{hint.key}</kbd>
      <span className="target-hint__label">{hint.label}</span>
    </div>
  );
};

export default TargetHint;
